/***********************************************
 * useWaveform
 *
 * Implement the wavesurfer library
 * https://wavesurfer-js.org/docs/
 *
 * Supports waveform with player or media stream
 *
 * onWaveformFinish can be assigned a callback for playback end.
 ***********************************************/
import { ref } from "vue";
import WaveSurfer from "wavesurfer.js";
export const useStreamWaveform = (initalConfig) => {
    const config = initalConfig || ref({});
    const frequency = 150;
    const wavesurfer = ref(null);
    const analyser = ref();
    let analyserJob;
    // Waveform Streaming
    const waveformStreamPlay = (el, analyserRef) => {
        config.value.container = el.value;
        analyser.value = analyserRef.value;
        wavesurfer.value = WaveSurfer.create(config.value);
        clearInterval(analyserJob);
        analyserJob = setInterval(updatePeaks, frequency);
    };
    const updatePeaks = () => {
        if (!analyser.value)
            return;
        const array = new Float32Array(analyser.value.frequencyBinCount);
        analyser.value.getFloatTimeDomainData(array);
        const peaks = Array.from(array.values());
        wavesurfer.value?.empty();
        wavesurfer.value?.backend.setPeaks(peaks, analyser.value.frequencyBinCount);
        wavesurfer.value?.drawBuffer();
    };
    const stopWaveformStreamPlay = () => {
        if (analyserJob) {
            clearInterval(analyserJob);
        }
    };
    const waveformDestroy = () => {
        if (wavesurfer.value) {
            // Clean up streaming
            if (analyserJob) {
                clearInterval(analyserJob);
            }
            wavesurfer.value.destroy();
            wavesurfer.value = null;
        }
    };
    return {
        waveformDestroy,
        waveformStreamPlay,
        stopWaveformStreamPlay,
        wavesurfer
    };
};
